var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonHollow = function SvgPersonHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.997 2.604a6.667 6.667 0 1 0 0 13.333 6.667 6.667 0 0 0 0-13.333M11.29 17.687c-3.486.953-5.958 3.984-5.958 7.584v2.666c0 .737.596 1.334 1.333 1.334H25.33c.736 0 1.333-.597 1.333-1.334v-2.666c0-3.6-2.473-6.631-5.959-7.584a1.27 1.27 0 0 0-.874.084 9.3 9.3 0 0 1-3.834.833 9.3 9.3 0 0 1-3.833-.833 1.27 1.27 0 0 0-.875-.084"
  })));
};
export default SvgPersonHollow;